































































import { Vue, Component } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider } from 'vee-validate-3';

import InternationalizationService from '@/api/InternationalizationService';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ModalOptions from '@/components/Modal/ModalOptions';
import CountrySelect from '@/componentsV2/molecules/CountrySelectV2/CountrySelect.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

import { setSessionSignup } from '@/views/Signup/session';

import {
  ECountries,
  EInternationalizationStatus,
  EUnavailableStatus
} from '@/models/internationalization';

import eventBus from '@/utils/eventBus';
import { scrollToTop } from '@/utils/scrollToTop';

import { isExternalOauthSessionOnline } from '@/router/router-utils';

import { OnboardingURL } from '@/views/Onboarding/helpers';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    CountrySelect,
    FilledButton,
    Typography
  }
})
export default class YourStore extends Vue {
  internationalizationService = new InternationalizationService();

  formData = {
    country: this.yourStoreFormData.country
  };

  loading = false;
  loadingCountry = true;

  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  email = '';

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get yourStoreFormData() {
    return this.$store.getters['businessOnboarding/getYourStoreForm'];
  }

  get yourStoreDetailsFormData() {
    return this.$store.getters['businessOnboarding/getStoreDetailsForm'];
  }

  get shouldNotify() {
    return this.formData.country.status === EInternationalizationStatus.UNDATED;
  }

  get currentCountry() {
    return this.$store.getters['internationalization/getCurrentCountry'];
  }

  get hasSelectedCountry() {
    return !!Object.values(this.formData.country).length;
  }

  get isOnlineSignup() {
    return isExternalOauthSessionOnline();
  }

  handleEmailInput(email: string) {
    this.email = email;
  }

  setCountryOnSignUpSession() {
    const country = this.formData.country;

    const isPopularCountry = !Object.values(EUnavailableStatus).includes(
      country.status as EUnavailableStatus
    );

    if (isPopularCountry) {
      setSessionSignup({
        country: country.name as ECountries,
        countryIso2: country.countryIso2
      });
    }
  }

  async onSubmit() {
    const formRef = this.$refs.observer;
    const formIsValid = await formRef.validate();

    if (!formIsValid) {
      this.$notification(
        String(this.$t('common.alerts.highlightedItemsError')),
        'error'
      );

      return;
    }

    this.setCountryOnSignUpSession();

    this.$store.dispatch(
      'businessOnboarding/SET_SELECTED_COUNTRY',
      this.formData.country
    );

    if (
      !this.yourStoreDetailsFormData.phone ||
      !this.yourStoreDetailsFormData.phone.number
    )
      this.$store.dispatch('businessOnboarding/SET_STORE_DETAILS_FORM', {
        ...this.yourStoreDetailsFormData,
        phone: {
          iso: this.formData.country.countryIso2,
          code: this.formData.country.phoneCode
        }
      });
    if (
      this.formData.country.status === EInternationalizationStatus.ONLINE_ONLY
    ) {
      this.$store.dispatch(
        'businessOnboarding/SET_OPERATION_TYPE',
        IBusinessType.ONLINE
      );
      this.$router.push(OnboardingURL.YOUR_BUSINESS_PROVIDERS);
      return;
    }
    this.$store.dispatch('businessOnboarding/SET_OPERATION_TYPE', '');

    this.$router.push(OnboardingURL.YOUR_BUSINESS_OPERATION);
  }

  async handleNotifyMe() {
    try {
      const formRef = this.$refs.observer;
      const formIsValid = await formRef.validate();

      if (!formIsValid) {
        this.$notification(
          String(this.$t('common.alerts.highlightedItemsError')),
          'error'
        );

        return;
      }

      this.loading = true;

      const {
        status
      } = await this.internationalizationService.reportNewIntegrationWithoutUser(
        {
          type: 'country',
          comment: this.formData.country.name,
          email: this.email
        }
      );
      if (status !== 201) return;

      eventBus.$emit(
        'openSubModal',
        new ModalOptions(
          ``,
          ``,
          'none',
          true,
          ``,
          ``,
          ``,
          false,
          'newCountryNotifyModal',
          false,
          true,
          true
        ),
        {
          buttonLabel: 'Got it',
          email: this.email,
          onConfirm: () => {
            eventBus.$emit('closeModal');
            eventBus.$emit('resetSignupCountrySelect');
          },
          onClose: () => {
            eventBus.$emit('closeModal');
            eventBus.$emit('resetSignupCountrySelect');
          },
          countryName: this.formData.country.name
        }
      );
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    scrollToTop('bo-base-layout__right');

    try {
      this.loadingCountry = true;

      if (this.$store.getters['internationalization/getCurrentCountry']) {
        return;
      }
      const {
        data
      } = await this.internationalizationService.getCurrentCountry();

      if (!data) return;

      this.$store.dispatch('internationalization/SET_CURRENT_COUNTRY', data);
    } finally {
      setTimeout(
        () => {
          this.loadingCountry = false;
        },
        window.previousRouteName ? 0 : 1000
      );
    }
  }
}
